import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating a view component
import {
    profile, // User profile information
    devConfig, // Development configuration settings
    countries, // List of countries
    paymentSystem, // Payment system configurations
    cashDesks, // Cash desk configurations
    agentList, // List of agents
} from 'config/config'; // Importing configuration constants from the config module

/**
 * Class representing a view for filtering square day reports.
 * @extends JetView
 */
export default class FilterSquareDayReport2View extends JetView {
    /**
     * Defines the configuration for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and the current screen size
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Define the left section of the form layout
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            // Text input for datepicker display
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true, // Make the field read-only
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                        },
                        {
                            // Datepicker input for selecting a date
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true, // Return date as a string
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: moment().format('YYYY-MM-DD'), // Default value as today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit selection to today or earlier
                                },
                            },
                        },
                        {
                            // Text input for User ID
                            view: 'text',
                            name: 'UserId',
                            type: 'number', // Input type is number
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Localized label
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Show based on permission
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Localized placeholder
                        },
                        {
                            // Text input for User Name
                            view: 'text',
                            name: 'Name',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('Nombre'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Localized placeholder
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Show based on permission
                            ),
                            css: 'prm-filterByUser',
                        },
                        {
                            // Text input for User Login
                            view: 'text',
                            name: 'Login',
                            minWidth: 200,
                            label: _('Login'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Login'), // Localized placeholder
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Show based on permission
                            ),
                            css: 'prm-filterByUser',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            // Combo box for selecting Bet Shop
                            view: 'combo',
                            name: 'BetShopId',
                            minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            id: 'BetShopId',
                            options: {
                                body: {
                                    // Function to fetch Bet Shops based on user input
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display the fetched data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            // Text input for Product
                            view: 'text',
                            name: 'Product',
                            minWidth: 200,
                            label: "<span class='icon-cubes'></span>" + _('Producto:'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Producto'), // Localized placeholder
                        },
                        {
                            // Combo box for selecting Level
                            view: 'combo',
                            label: _('Nivel'), // Localized label
                            name: 'Nivel',
                            labelPosition: 'top',
                            minWidth: 200,
                            options: [
                                { id: '', value: _('Punto de Venta') }, // Option for Point of Sale
                                { id: 'C', value: _('Con Cajero') }, // Option for With Cashier
                            ],
                        },
                    ],
                },
            ],
        };

        // Define the upper section of the form layout
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include the left section
                },
            ],
        };

        // Define the buttons section of the form
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        {
                            // Button to close a specific day
                            view: 'button',
                            value: _('Cerrar día especifico'), // Localized label
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            click: () => {
                                this.app.callEvent('closeSpecificDay', [{}]); // Trigger event to close specific day
                            },
                        },
                        {
                            // Button for mass export
                            view: 'button',
                            value: _('Exportación Masiva'), // Localized label
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                                    }
                                }
                                this.app.callEvent('customer3:updateFinance2', [
                                    filterdata, // Trigger event with filter data
                                ]);
                            },
                        },
                        {
                            // Button to clear the form
                            view: 'button',
                            value: _('Limpiar'), // Localized label
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            // Button to consult/filter data
                            view: 'button',
                            value: _('Consultar'), // Localized label
                            hotkey: 'enter', // Set hotkey for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                                    }
                                }
                                this.app.callEvent('squareDay2:filter', [
                                    filterdata, // Trigger event with filter data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };

        // Define the accordion section of the form layout
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Start collapsed
                    type: 'clean',
                    rows: [
                        {
                            // Button to consult/filter data in mobile view
                            view: 'button',
                            value: _('Consultar'), // Localized label
                            hotkey: 'enter', // Set hotkey for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            id: 'consultMobile',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                                    }
                                }
                                this.app.callEvent('squareDay2:filter', [
                                    filterdata, // Trigger event with filter data
                                ]);
                            },
                        },
                        {
                            // Header for filters section
                            header: _('Filtros'), // Localized label
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [accordion_section], // Include accordion section
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        }; // Placeholder for the view's configuration content
    }

    /**
     * Initializes the view with the provided grid.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        webix.ready(function () {
            // Check if the screen width is less than 500 pixels
            if (screen.width < 500) {
                // Hide the consult desk element for small screens
                $$('consultDesk').hide();
            }
            // Check if the screen width is 500 pixels or more
            if (screen.width >= 500) {
                // Hide the consult mobile element for larger screens
                $$('consultMobile').hide();
            }
            // Check if the profile typeDate is not equal to 2
            if (profile.typeDate !== 2) {
                // Hide the Date element and show the Datepicker element
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                // If the profile typeDate is equal to 2
                if (true) {
                    // Show the Date element and hide the Datepicker element
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });

        // Get the current language setting from the app's locale service
        const lang = this.app.getService('locale').getLang();

        // Attach an event handler for the 'onAfterRender' event of the Datepicker
        $$('Datepicker').attachEvent('onAfterRender', function () {
            // Set the date modal configuration based on the current language
            devConfig.setDateModal(lang);
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
